(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eplab-gallery-design"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('eplab-gallery-design')){
customElements.define('eplab-gallery-design',class extends HTMLElement{
  connectedCallback(){
    if(this.controller)this.controller.abort();
    this.controller=new AbortController();
    const options={signal:this.controller.signal};
    this.photos=Array.from(this.querySelectorAll('[data-photo]'));
    this.filtered=this.photos.slice();
    this.nav=this.querySelector('.epg__pages');
    this.filters=this.querySelector('.epg__filters');
    this.dialog=this.querySelector('dialog');
    this.countNode=this.querySelector('.epg__count');
    this.empty=this.querySelector('.epg__empty');
    this.activeFilter='all';
    this.page=0;
    this.filters.hidden=false;
    this.addEventListener('click',event=>{
      const filter=event.target.closest('[data-filter]');
      if(filter){this.activeFilter=filter.dataset.filter;this.filtered=this.photos.filter(p=>this.activeFilter==='all'||p.dataset.category===this.activeFilter);this.filters.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b===filter)));this.showPage(0);return;}
      const open=event.target.closest('[data-open]');
      if(open&&this.dialog&&this.dataset.zoom==='true'){this.openPhoto(this.filtered.indexOf(open.closest('[data-photo]')));return;}
      if(event.target.closest('[data-prev]'))this.move(-1);
      if(event.target.closest('[data-next]'))this.move(1);
    },options);
    if(this.dialog){
      this.dialog.addEventListener('click',event=>{if(event.target===this.dialog)this.dialog.close();},options);
      this.dialog.addEventListener('keydown',event=>{if(event.key==='ArrowRight'){event.preventDefault();this.move(1);}if(event.key==='ArrowLeft'){event.preventDefault();this.move(-1);}},options);
      this.dialog.addEventListener('close',()=>{this.releaseScroll();if(this.opener&&this.opener.isConnected)this.opener.focus();},options);
    }
    this.addEventListener('shopify:block:select',event=>{
      const photo=event.target.closest('[data-photo]');
      if(!photo)return;
      if(this.activeFilter!=='all'){this.filters.querySelector('[data-filter="all"]').click();}
      this.showPage(Math.floor(this.filtered.indexOf(photo)/20));
    },options);
    this.showPage(0);
  }
  disconnectedCallback(){if(this.dialog&&this.dialog.open)this.dialog.close();this.releaseScroll();if(this.controller)this.controller.abort();}
  showPage(page){
    const totalPages=Math.ceil(this.filtered.length/20);
    this.page=Math.max(0,Math.min(page,Math.max(0,totalPages-1)));
    const visible=new Set(this.filtered.slice(this.page*20,(this.page+1)*20));
    this.photos.forEach(photo=>{photo.hidden=!visible.has(photo);});
    this.empty.hidden=this.filtered.length!==0;
    this.countNode.textContent=this.dataset.countLabel.replace('[count]',String(this.filtered.length));
    this.nav.replaceChildren();
    this.nav.hidden=totalPages<2;
    for(let p=0;p<totalPages;p++){
      const button=document.createElement('button');
      button.type='button';
      button.textContent=String(p+1);
      button.setAttribute('aria-label',this.dataset.pageLabel.replace('[number]',String(p+1)));
      if(p===this.page)button.setAttribute('aria-current','page');
      button.addEventListener('click',()=>{this.showPage(p);this.querySelector('.epg__grid').scrollIntoView({block:'start',behavior:'auto'});});
      this.nav.append(button);
    }
  }
  openPhoto(index){
    if(index<0||!this.dialog||!this.filtered.length)return;
    this.photoIndex=index;
    this.opener=this.filtered[index].querySelector('[data-open]');
    this.renderPhoto();
    if(!this.dialog.open){this.savedOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';this.scrollLocked=true;this.dialog.showModal();}
  }
  renderPhoto(){
    const photo=this.filtered[this.photoIndex],source=photo.querySelector('[data-open]');
    const image=this.dialog.querySelector('.epg__full');
    image.src=source.dataset.full;
    image.alt=photo.dataset.alt;
    this.dialog.querySelector('.epg__dialog-caption').textContent=photo.dataset.caption;
    this.dialog.querySelector('[data-prev]').hidden=this.filtered.length<2;
    this.dialog.querySelector('[data-next]').hidden=this.filtered.length<2;
  }
  move(delta){if(!this.dialog||!this.dialog.open||!this.filtered.length)return;this.photoIndex=(this.photoIndex+delta+this.filtered.length)%this.filtered.length;this.renderPhoto();}
  releaseScroll(){if(this.scrollLocked){document.documentElement.style.overflow=this.savedOverflow||'';this.scrollLocked=false;}}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.headerCoords = {};
      this.calcHeaderCoords();

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    calcHeaderCoords() {
      const clientRect = this.getBoundingClientRect();
      const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
      this.headerCoords.bottom = pageYOffset + clientRect.bottom;
      this.headerCoords.top = pageYOffset + clientRect.top;
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky) {
        if (scrollTop > this.header.offsetHeight + 1) {
          this.header.classList.add('shopify-section-header-sticky');

          if (this.header.classList.contains('color-background-overlay')) {
            this.header.classList.remove('color-background-overlay');
            this.header.classList.add('color-background-overlay-hidden');
          }
        }

        if (scrollTop < this.header.offsetHeight) {
          this.header.classList.remove('shopify-section-header-sticky');

          if (this.header.classList.contains('color-background-overlay-hidden')) {
            this.header.classList.add('color-background-overlay');
            this.header.classList.remove('color-background-overlay-hidden');
          }
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerCoords.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');

      if (this.header.classList.contains('color-background-overlay')) {
        this.header.classList.remove('color-background-overlay');
        this.header.classList.add('color-background-overlay-hidden');
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

      if (this.header.classList.contains('color-background-overlay-hidden')) {
        const megaMenus = Array.from(document.querySelectorAll('.mega-menu'));
        if (megaMenus.some((megaMenu) => megaMenu.hasAttribute('open'))) return;
        this.header.classList.add('color-background-overlay');
        this.header.classList.remove('color-background-overlay-hidden');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      if (customElements.get('details-disclosure')) {
        this.disclosures.forEach((disclosure) => {
          disclosure.close();
        });
      }

      this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
      this.disclosureLists.forEach((disclosureList) => {
        disclosureList.setAttribute('hidden', true);
      });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
